module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./StoreInfoView.js"));
	}, "StoreInfoView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=StoreInfoView!./src/pages/Store/InfoManage/StoreInfo/StoreInfoView.js
// module id = 1220
// module chunks = 431